class HeaderAppearanceConfig extends BasicAppearanceConfig {
    visible: KnockoutObservable<boolean>;
    backColor: KnockoutObservable<string>;
    border: KnockoutObservable<boolean>;
    borderColor: KnockoutObservable<string>;
    fontSize: KnockoutObservable<number>;
    fontBold: KnockoutObservable<boolean>;
    fontItalic: KnockoutObservable<boolean>;
    //fontColor: KnockoutObservable<string>;
    fontAlignment: KnockoutObservable<FontAlignmentEnum>;

    //fontColorUI: KnockoutComputed<string>;
    fontAlignmentUI: KnockoutComputed<string>;

    constructor(data: any, dashboard: Dashboard) {
        super(data, dashboard);

        this.visible = ko.observable(data.visible);
        this.backColor = ko.observable(data.backColor);
        this.border = ko.observable(data.border);
        this.borderColor = ko.observable(data.borderColor);
        this.fontSize = ko.observable(data.fontSize);
        this.fontBold = ko.observable(data.fontBold);
        this.fontItalic = ko.observable(data.fontItalic);
        //this.fontColor = ko.observable(data.fontColor);
        this.fontAlignment = ko.observable(data.fontAlignment);

        //this.fontColorUI = ko.computed(() => { return this.fontColor() ?? "#333"; }, this);

        this.fontAlignmentUI = ko.computed(() => {
            switch (this.fontAlignment()) {
                case FontAlignmentEnum.Center:
                    return "center";
                case FontAlignmentEnum.Start:
                    return "start";
                case FontAlignmentEnum.End:
                    return "end";
            }
        }, this);
    }
}